import axios from "../../plugins/axios-common";

export default {
  actions: {
    importOrder (_, payload) {
      console.log(payload)
      return new Promise((resolve, reject) => {
        const settings = {
          method: "POST",
          data: payload,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        };
        axios("/api/cash/order/import-order", settings).then((resp) => {
          resolve(resp.data)
        }).catch((e) => {
          reject(e)
        })
      })
    },
    getRecommendations () {
      return new Promise((resolve, reject) => {
        axios.get("/api/cash/recommendation-templates").then((resp) => {
          resolve(resp.data)
        }).catch((e) => {
          reject(e)
        })
      })
    },
    getAPIPaymentState (_, orderid) {
      return new Promise((resolve, reject) => {
        const body = {
          orderId: orderid,
        };
        const settings = {
          method: "POST",
          data: body,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        };
        axios("/api/paymentctrlstatus", settings).then((resp) => {
          resolve(resp.data)
        }).catch((e) => {
          reject(e)
        })
      })
    },
    setPaymentModal({ commit }, newState) {
        commit("setPaymentModal", newState);
    },
    setChangeClientModal({ commit }, newState) {
        commit("setChangeClientModal", newState);
    },
    fetchReasons({ commit, rootState }) {
      const tmp = {}
      tmp[rootState.login.chosenDirection] = true
      commit("updateLastChosenDirection", rootState.login.chosenDirection);
      axios.get("/api/cash/reasons.json", { params: tmp}).then((resp) => {
        commit("updateReasons", resp.data);
      });
    },
    fetchServices({ commit, rootState,rootGetters }, [reasonId, runflat, frameVehicle]) {
      let serviceUrl = `api/cash/services.json?reason=${reasonId}&diskType=${rootState.clientCard.diskType}
			&diskSize=${rootState.clientCard.diskSize}
			&runflat=${rootState.clientCard.runflat}&framevehicle=${rootState.clientCard.frameVehicle}`;
      console.log('rootState.clientCard', rootState.clientCard);
      if (rootState.clientCard.carTypeArr.length > 0) {
        // console.log('clientCard have carTypeArr', rootState.clientCard.carTypeArr)
        const carTypeIndex = rootState.clientCard.carTypeArr.findIndex(ct => ct.service.slug === rootGetters["login/chosenDirectionSlug"])
        if(carTypeIndex > -1) {
          serviceUrl += '&' + rootGetters["login/chosenDirectionSlug"] + '=' + rootState.clientCard.carTypeArr[carTypeIndex].slug
        }
      }
      axios.get(serviceUrl).then((res) => {
        const services = res.data;
        if (services.length > 0)
          services.forEach((x) => {
            x.quantity = 1;
          });
        commit("updateServices", services);
        commit("setServicesLoad", true);
        commit("clearCalcSubTypes");
        services.forEach((item) => {
          if (item.calc_subtype) {
            commit("updateCalcSubTypes", item);
          }
        });
        if (runflat || frameVehicle) {
          commit("updatePrice");
        }
      });
    },
    fetchPromocodes({ commit }) {
      axios.get("/client/promocodes.json").then((resp) => {
        commit("updatePromocodes", resp.data);
      });
    },
    addServiceToCart({ commit, state, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const price = payload.price ? payload.price : payload.service.price;
        const id = payload.id ? payload.id : payload.service.id;
        const cartItem = state.chosenServices.find(
            (item) => item.id === id && item.price === price && !(item.params && payload.params && item.params.text !== payload.params.text)
        );
        if (!cartItem) {
          commit("pushServiceToCart", {
            id: id,
            title: payload.service.title,
            price: price,
            need_tighten: payload.service.need_tighten,
            quantity: payload.quantity ? payload.quantity : 1,
            type: payload.service.pivot && payload.service.pivot.commodity_id ? "commodity" : "service",
            calc_type: payload.service.calc_type,
            manual_discount: payload.service.manual_discount,
            params: payload.params || "",
            side: payload.params?.content?.item?.side ?? '',
          })
        } else {
          if (payload.quantity && payload.quantity > 1) {
            commit("multiplicationItemQuantity", [cartItem, payload.quantity]);
          } else {
            commit("incrementItemQuantity", cartItem);
          }
        }
        dispatch("fetchPricesWithCartItems", {
          cart: state.chosenServices,
          promocode: state.chosenPromocode,
          client: payload.client,
        }).then((resp) => {
          resolve(resp)
        }).catch((e) => {
          reject(e)
        })
      })
    },
    async fetchPricesWithCartItems({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const body = {
          cart: payload.cart,
          promocode: payload.promocode,
          client: payload.client,
        };
        const settings = {
          method: "POST",
          data: body,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        };
        axios("/api/cash/order/cart", settings)
            .then((response) => {
              const cart = response.data;
              commit("updateCart", cart);
              resolve(response)
            })
            .catch((e) => {
              console.log("Error fetching Cart ", e);
              reject(e)
            });
      })
    },
    async postOrder({ commit, state, rootState }, payload) {
      return new Promise((resolve, reject) => {
        const body = {
          cart: payload.cart,
          client: payload.client,
          clientPhone: payload.clientPhone,
          clientName: payload.clientName,
          promocode: payload.promocode,
          shift: payload.shift,
          status: payload.status,
          mark: payload.mark,
          model: payload.model,
          runflat: payload.runflat,
          frameVehicle: payload.frameVehicle,
          employee: payload.employee,
          params: {
            diskSize: rootState.clientCard.diskSize,
            diskType: rootState.clientCard.diskType,
            carType: rootState.clientCard.carType,
            carTypeArr: rootState.clientCard.carTypeArr,
            carId: rootState.clientCard.chosenCarId,
            plateNumber: rootState.clientCard.plateNumber,
            car: payload.mark + " " + payload.model,
            carMark: payload.mark,
            carModel: payload.model,
          },
          queueId: state.queueId,
        }
        const settings = {
          method: "POST",
          data: body,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
        axios("/api/cash/order/openorder", settings).then((res) => {
          const order = res.data;
          commit("updateOrder", order);
          commit("updateClientId", order.user_id);
          resolve(order)
        }).catch((e) => {
          reject(e)
        });
      })
    },
    updateOrder({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        const body = {
          client: payload.client,
          clientPhone: payload.clientPhone,
          promocode: payload.promocode,
          shift: payload.shift,
          status: payload.status,
          mark: payload.mark,
          model: payload.model,
          order_id: payload.order_id,
          cart: payload.cart,
          runflat: payload.runflat,
          frameVehicle: payload.frameVehicle,
          employee: payload.employee ?? "",
          params: {
            carTypeArr: rootState.clientCard.carTypeArr,
            carId: rootState.clientCard.chosenCarId,
            diskSize: rootState.clientCard.diskSize,
            diskType: rootState.clientCard.diskType,
            carType: rootState.clientCard.carType,
            plateNumber: rootState.clientCard.plateNumber,
            car: payload.mark + " " + payload.model,
            carMark: payload.mark,
            carModel: payload.model,
            reasonDirection: rootState.login.chosenDirection,
            questionnaire: payload.questionnaire ?? "",
            recommendations: payload.recommendations ?? ""
          }
        };
        const settings = {
          method: "POST",
          data: body,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        };
        axios("/api/cash/order/updateorder", settings)
          .then((res) => {
            const order = res.data;
            commit("updateOrder", order);
            resolve(order);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    postPayment({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const settings = {
          method: "POST",
          data: payload,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        };
        axios("/api/paymentctrl", settings)
          .then((res) => {
            const payment = res.data;
            commit("updatePayment", payment);
            resolve(payment);
          })
          .catch((e) => {
            console.log('err connect:', e)
            reject(e);
          });
      });
    },
    postReprintJob({ state }) {
      return new Promise((resolve, reject) => {
        const body = { id: state.ctrlJobId };
        const settings = {
          method: "POST",
          data: body,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        };
        axios("api/paymentctrlreprint", settings)
          .then((resp) => {
            const reprintCtrlJobId = resp.data;
            // commit("updatePaymentDocsStatus", paymentDocsStatus);
            resolve(reprintCtrlJobId);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    fetchReceiptStatus({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const body = { original: payload.original };
        const settings = {
          method: "POST",
          credentials: "same-origin",
          data: body,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        };
        axios("/api/paymentctrlstatus", settings)
          .then((resp) => {
            const paymentDocsStatus = resp.data;
            commit("updatePaymentDocsStatus", paymentDocsStatus);
            resolve(paymentDocsStatus);
          })
          .catch((e) => {
            console.log("Error:", e);
            reject(e);
          });
      });
    },
    refundPayment(_, payload) {
      return new Promise((resolve, reject) => {
        const body = {
          orderId: payload,
          payment_type: 'card'
        };
        console.log(payload)
        const settings = {
          method: "POST",
          data: body,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        };
        axios("api/paymentctrlrefund", settings).then((resp) => {
          resolve(resp.data)
        }).catch((err) => {
          reject(err)
        })
      })
    },
    postRefund({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const body = {
          orderId: payload.order_id,
          payment_type: "card",
          order_id: payload.order_id,
          amount: payload.amount,
          master_id: payload.master_id,
        };
        console.log('body', body)
        const settings = {
          method: "POST",
          data: body,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        };
        axios("/api/cash/order/refund", settings)
          .then((res) => {
            const payment = res.data;
            dispatch("fetchReceiptStatus", { original: payment.original });
            resolve(payment);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    postReprint(payload) {
      return new Promise((resolve, reject) => {
        const body = {
          uuid: payload.uuid,
          orderId: payload.orderId,
        };
        const settings = {
          method: "POST",
          data: body,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        };
        axios("/api/cash/order/reprint", settings)
          .then((res) => {
            const reprint = res.data;
            resolve(reprint);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    async fetchOrder({ commit, state, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        console.log("fetching order...");
        const body = {
          order_id: payload.order_id,
          load_order: true,
        };
        const settings = {
          method: "POST",
          data: body,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        };
        axios("/api/cash/order/fetchorder", settings)
          .then((res) => {
            if (res) {
              const order = res.data;
              if (res.data.params && res.data.params.reasonDirection) {
                commit('login/setChosenDirection', res.data.params.reasonDirection)
              }
              if(!order.params) {
                order.params = {
                  carType:'',
                  diskType:'',
                  diskSize:'',
                  runflat:'',
                  frameVehicle:'',
                  carMark:'',
                  carId:'',
                  carTypeArr:'',
                };
              }
              Promise.all([
                commit("updateOrder", order),
                commit("updateCarType", order.params.carType, { root: true }),
                commit("updateDiskType", order.params.diskType, { root: true }),
                commit("updateDiskSize", order.params.diskSize, { root: true }),
                commit("updateRunflat", order.params.runflat, { root: true }),
                commit("updateFrameVehicle", order.params.frameVehicle, { root: true }),
                commit("updateChosenMark", order.params.carMark, { root: true }),
                commit("updateChosenModel", order.params.carModel, { root: true }),
                commit("updateChosenCarId", order.params.carId, { root: true }),
                commit("updateCarTypeArr", order.params.carTypeArr, { root: true }),
                commit("updateChosenPromocode",  JSON.parse(JSON.stringify({
                  code: order.promocode,
                  amount: order.promocode_discount,
                  // TODO: remove hardcoded promocode type
                  type: 'percents'
                })), {root: true}),
                commit(
                  "updatePlateNumber",
                  order.user_car ? order.user_car.plate_number : "",
                  { root: true }
                ),
              ]).then(() => {
                // state.cart.services = order.services

                Promise.all([
                    dispatch("fetchClient", {
                      searchString: order.user_id,
                      type: "byId",
                    }),
                    dispatch("fetchChosenServicesFromOrder", order),
                ]).then(([client, cs]) => {
                  dispatch("fetchPricesWithCartItems", {
                    cart: cs,
                    promocode: state.chosenPromocode,
                    client: client,
                  })
                })
                resolve("ok")
              })
              commit("setOrderLoaded", true)
            }
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    fetchChosenServicesFromOrder({ commit }, order) {
      return new Promise((resolve) => {
        //put services in chosenServices
        const chosenServices = [];
        order.services.forEach((service) => {
          chosenServices.push({
            id: service.id,
            manual_discount: service.manual_discount,
            manual_set_price: service.pivot.manual_price,
            need_tighten: service.need_tighten,
            original_price: service.pivot.original_price,
            params: service.params,
            price: service.pivot.price,
            quantity: service.pivot.quantity,
            title: service.title,
            type: service.pivot.servicable_type === "App\\Models\\Service" ? 'service' : 'commodity'
          });
        });
        commit("updateChosenServices", chosenServices);
        resolve(chosenServices)
      })
      //put services in cart
    },
    async prevOrderStatus({ commit }, payload) {
      const body = {
        order_id: payload.order_id,
      };
      const settings = {
        method: "POST",
        data: body,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };
      axios("/api/cash/order/prevstatus", settings).then((res) => {
        const order = res.data;
        commit("updateOrder", order);
      });
    },
  },
  mutations: {
    setPaymentModal (state, newState) {
      state.paymentModal = newState
    },
    setChangeClientModal (state, newState) {
      state.changeClientModal = newState
    },
    setCtrlJobId (state, id) {
      state.ctrlJobId = id;
    },
    clearCtrlJobId (state) {
      state.ctrlJobId = null;
    },
    setPaymentRefund (state, newState) {
      state.paymentRefund.state = newState.state
      state.paymentRefund.order = newState.order
    },
    clearPaymentRefund (state) {
      state.paymentRefund.state = false
      state.paymentRefund.order = null
    },
    updatePaymentDocsStatus(state, paymentDocsStatus) {
      state.paymentDocsStatus = paymentDocsStatus;
    },
    clearCalcSubTypes(state) {
      state.calcSubTypes = [];
    },
    updateCalcSubTypes(state, item) {
      state.calcSubTypes.push(item);
    },
    fetchServices(state, { reasonId, carType }) {
      state.reasonId = reasonId;
      state.carType = carType;
    },
    updateLastChosenDirection (state, direction) {
      state.lastChosenDirection = direction;
    },
    updateReasons(state, reasons) {
      state.reasons = reasons;
    },
    updatePrice(state) {
      if (state.services) {
        state.services.forEach((x) => {
          if (x.additional_price) {
            x.price = parseInt(x.price, 10) + parseInt(x.additional_price, 10);
            x.price = x.price + ".00";
          }
        });
      }
    },
    updateServices(state, services) {
      state.services = JSON.parse(JSON.stringify(services));
    },
    updateServicesPrice(state, [id, value]) {
      state.services[id].price = value + ".00";
    },
    updatePromocodes(state, promocodes) {
      state.promocodes = promocodes;
    },
    updateChosenPromocode(state, chosenPromocode) {
      if(chosenPromocode.code) {
        state.chosenPromocode = chosenPromocode;
      } else {
        state.chosenPromocode = ""
      }
    },
    updateChosenServices(state, chosenServices) {
      state.chosenServices = chosenServices;
    },
    // updateWheelsSides(state, [id, params]){
    //     console.log(state.services[id].params)
    // },
    clearServices(state) {
      state.services = {};
    },
    pushServiceToCart(state, payload) {
      state.chosenServices.push({
        id: payload.id,
        title: payload.title,
        price: payload.price,
        original_price: payload.price,
        need_tighten: payload.need_tighten,
        quantity: payload.quantity,
        type: payload.type,
        calc_type: payload.calc_type,
        params: payload.params ?? "",
        manual_discount: payload.manual_discount,
        side: payload.side,
      });
    },
    removeServiceFromCart(state, index) {
      state.chosenServices.splice(index, 1);
      state.cart.services.splice(index, 1);
    },
    removeAllServiceFromCart(state) {
      state.chosenServices = [];
      state.cart.services = [];
    },
    updateCart(state, cart) {
      state.cart = cart;
    },
    setSelectedCalc(state, value) {
      state.selectedCalc = value;
    },
    setServicesLoad(state, value) {
      state.servicesLoad = value;
    },
    incrementItemQuantity(state, payload) {
      payload.quantity++;
    },
    multiplicationItemQuantity(state, [cartItem, quantity]) {
      cartItem.quantity = cartItem.quantity + quantity;
    },
    updateOrder(state, order) {
      state.order = order;
    },
    updatePayment(state, payment) {
      state.payment = payment;
    },
    nextStep(state, steps = 1) {
      state.step += steps;
    },
    prevStep(state, steps = 1) {
      state.step -= steps;
    },
    goToStep(state, step) {
      state.step = step;
    },
    addManualPriceFlag(state, service) {
      // console.log(service)
      state.chosenServices[service].manual_set_price = true;
    },
    setOrderLoaded(state, value) {
      state.OrderLoaded = value;
    },
    updateOrderError(state, value) {
      state.orderError = value;
    },
    hideTightenDialog(state) {
      state.tightenDialog = false;
    },
    showTightenDialog(state) {
      state.tightenDialog = true;
    },
    hideServiceInfoModal(state) {
      state.serviceInfoModal.show = false;
    },
    showServiceInfoModal(state, value) {
      state.serviceInfoModal.show = true;
      state.serviceInfoModal.title = value.title || null;
      state.serviceInfoModal.description = value.description || null;
      state.serviceInfoModal.content = value.content || null;
      state.serviceInfoModal.duration = value.duration || null;
      state.serviceInfoModal.paymentInfo = value.master_sallary || null;
      state.serviceInfoModal.warranty = value.warranty || null;
      state.serviceInfoModal.warranty_period = value.warranty_period || null;
      state.serviceInfoModal.traningVideo = value.traningVideo || null;
      state.serviceInfoModal.techCard = value.techCard || null;
      state.serviceInfoModal.presentation = value.presentation || null;
    },
    resetChoosenServicesComponent(state) {
      state.cart = {};
      state.services = {};
      state.chosenServices = [];
      state.payment = {};
      state.order = {};
      state.chosenPromocode = "";
      (state.selectedCalc = null), (state.nextOrderStatus = "");
    },
    updateQueueId(state, value) {
      state.queueId = value;
    },
    setCanEditClientCard(state, value) {
      state.canEditClientCard = value;
    },
    updateNextOrderStatus(state, value) {
      state.nextOrderStatus = value;
    },
  },
  state: {
    lastChosenDirection: null,
    serviceInfoModal: {
      show: false,
      image: null,
      title: null,
      description: null,
      content: null,
      warranty: null,
      warranty_period: null,
      traningVideo: null,
      techCard: null,
    },
    calcSubTypes: [],
    tightenDialog: false,
    servicesLoad: false,
    selectedCalc: null,
    reasons: {},
    services: {},
    promocodes: {},
    chosenPromocode: "",
    paymentDocsStatus: null,
    chosenServices: [],
    cart: {},
    order: {},
    orderLoaded: false,
    orderError: false,
    payment: {},
    queueId: "",
    canEditClientCard: false,
    step: 1,
    nextOrderStatus: "",
    paymentModal: false,
    changeClientModal: false,
    paymentRefund: {
      state: false,
      order: null,
    },
    ctrlJobId: null
  },
  getters: {
    ctrlJobId(state) {
      return state.ctrlJobId;
    },
    paymentRefund(state) {
      return state.paymentRefund;
    },
    paymentModal(state) {
      return state.paymentModal;
    },
    ChangeClientModal(state) {
      return state.changeClientModal;
    },
    paymentDocsStatus(state) {
      return state.paymentDocsStatus;
    },
    showServiceInfoModal(state) {
      return state.serviceInfoModal.show;
    },
    serviceInfoModal(state) {
      return state.serviceInfoModal;
    },
    tightenDialog(state) {
      return state.tightenDialog;
    },
    calcSubTypes(state) {
      return state.calcSubTypes;
    },
    servicesLoad(state) {
      return state.servicesLoad;
    },
    selectedCalc(state) {
      return state.selectedCalc;
    },
    reasons(state) {
      return state.reasons;
    },
    services(state) {
      return state.services;
    },
    promocodes(state) {
      return state.promocodes;
    },
    chosenPromocode(state) {
      return state.chosenPromocode;
    },
    chosenServices(state) {
      return state.chosenServices;
    },
    // chosenServices(state) {
    // 	return state.chosenServices.map(cartItem => {
    // 		const service = state.services.find(service => service.id === cartItem.id)
    // 		const clonedService = Object.assign({}, service)
    // 		return {
    // 			id: clonedService.id,
    // 			title: clonedService.title,
    // 			price: clonedService.price,
    // 			quantity: cartItem.quantity
    // 		}
    // 	})
    // },
    cart(state) {
      return state.cart;
    },
    order(state) {
      return state.order;
    },
    payment(state) {
      return state.payment;
    },
    step(state) {
      return state.step;
    },
    orderLoaded(state) {
      return state.orderLoaded;
    },
    orderError(state) {
      return state.orderError;
    },
    queueId(state) {
      return state.queueId;
    },
    canEditClientCard(state) {
      return state.canEditClientCard;
    },
    nextOrderStatus(state) {
      return state.nextOrderStatus;
    },
  },
};
